import React from "react";
import { ArrowRight } from "lucide-react";
import { buildWhatsAppLink, getContact } from "@/lib/site";
import { useContent } from "@/lib/content";
import { getIcon } from "@/lib/icons";

export default function Partnership() {
  const { content } = useContent();
  const p = content.partnership || {};
  const benefits = p.benefits || [];
  const link = buildWhatsAppLink(
    "Hi, our college would like to explore a partnership with Educators Institute of Management.",
    p.whatsapp_raw || getContact(content).whatsappRaw
  );
  return (
    <section id="partners" data-testid="partnership-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="bg-[#002570] rounded-[2rem] p-8 md:p-14 text-white relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#73c3ff]/20 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-[#73c3ff]/10 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <p className="font-inter text-sm font-semibold tracking-[0.18em] uppercase text-[#73c3ff]">{p.eyebrow || "For Colleges"}</p>
              <h2 className="mt-3 font-rubik text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-balance">
                {p.headline_pre || "Partner with Educators."} <span className="text-[#73c3ff]">{p.headline_emphasis || "Empower your campus."}</span>
              </h2>
              <p className="mt-5 font-inter text-base text-white/80 leading-relaxed">
                {p.body || "We collaborate with degree colleges and B-schools to bring globally recognised qualifications into the classroom — without disturbing their existing curriculum."}
              </p>
              <a href={link} target="_blank" rel="noreferrer" data-testid="partner-cta-btn" className="mt-8 inline-flex items-center gap-2 bg-white text-[#002570] hover:bg-[#73c3ff] rounded-full px-7 py-4 font-inter font-medium transition-all hover:shadow-xl">
                Partner With Us <ArrowRight className="w-4 h-4" />
              </a>
            </div>

            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => {
                const Icon = getIcon(b.icon);
                return (
                  <div key={i} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-5 hover:bg-white/10 transition-colors">
                    <div className="w-11 h-11 rounded-xl bg-[#73c3ff] text-[#002570] flex items-center justify-center mb-4">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-rubik text-base font-semibold">{b.title}</h3>
                    <p className="mt-1.5 font-inter text-sm text-white/75 leading-relaxed">{b.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
